import type {
  AddUserClubResponse,
  HgAddUserClubReply
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { lastValueFrom } from 'rxjs';

import useRequest from '@swf/core/hooks/useRequest';
import { ENDPOINTS, handleServerResponse } from '@swf/poker';

const useJoinPublicClub = () => {
  const request = useRequest();

  const joinPublicClub = async (clubId: number, userId: string) => {
    const { body } = await lastValueFrom(
      request({
        service: ENDPOINTS.club,
        http: true,
        method: 'PUT',
        body: {
          addUserClub: { clubId, clubPassword: 'public', comment: userId }
        }
      })
    );

    return handleServerResponse<AddUserClubResponse, HgAddUserClubReply>({
      response: body,
      accessor: 'addUserClubReply'
    });
  };

  return joinPublicClub;
};

export default useJoinPublicClub;
